module.exports = __webpack_public_path__ + "img/ezc-wt-kalamba.84b410fe.png";